export const ADMIN_MENU_ALL_ITEMS = [
  {
    key: "MENU_BAR.ADMIN.USERS.CLIENTS",
    id: "Clients"
  },
  {
    key: "MENU_BAR.ADMIN.USERS.CANDIDATES",
    id: "Candidates"
  },
  {
    key: "MENU_BAR.ADMIN.JOBS_EVENTS.SHIFT_JOB_CALENDAR",
    id: "Shift Job Calendar"
  },
  {
    key: "MENU_BAR.ADMIN.JOBS_EVENTS.PLACEMENT_JOBS",
    id: "Jobs"
  },
  {
    key: "MENU_BAR.ADMIN.TEMPLATES.ROOT",
    subItems: [
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.EMAIL",
        id: "Email Templates"
      },
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.SMS",
        id: "SMS Templates"
      },
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.DOCUMENT",
        id: "Document Templates"
      },
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.NOTE",
        id: "Note Templates"
      },
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.TASK",
        id: "Task Templates"
      },
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.PROFILE",
        id: "Profile Templates"
      },
      {
        key: "MENU_BAR.ADMIN.TEMPLATES.PUSH_NOTIFICATION",
        id: "Push Notification Templates"
      }
    ]
  },
  {
    key: "MENU_BAR.ADMIN.SETTINGS.ROOT",
    subItems: [
      {
        key: "MENU_BAR.ADMIN.SETTINGS.AGENCY",
        id: "Agency"
      },
      {
        key: "MENU_BAR.ADMIN.SETTINGS.ADMIN",
        id: "Admin Setting"
      }
    ]
  },
  {
    key: "MENU_BAR.ADMIN.BUILDERS.ROOT",
    subItems: [
      {
        key: "MENU_BAR.ADMIN.BUILDERS.PROFILE",
        id: "Application & Profile Builder"
      },
      {
        key: "MENU_BAR.ADMIN.BUILDERS.EVALUATION",
        id: "Evaluation Builder"
      }
    ]
  },
  {
    key: "MENU_BAR.ADMIN.LOGS.ROOT",
    subItems: [
      {
        key: "MENU_BAR.ADMIN.LOGS.COMMUNICATION_LOG",
        id: "Communication Log"
      },
      {
        key: "MENU_BAR.ADMIN.LOGS.USER_MESSAGES_LOG",
        id: "User Messages Log"
      },
      {
        key: "MENU_BAR.ADMIN.LOGS.STATUS_CHANGES",
        id: "Status Changes"
      },
      {
        key: "MENU_BAR.ADMIN.LOGS.ACTIVITY_LOG",
        id: "Activity Log"
      },
      {
        key: "MENU_BAR.ADMIN.LOGS.APPLICATION_LOG",
        id: "Application Log"
      },
      {
        key: "MENU_BAR.ADMIN.LOGS.PAYMENT_LOG",
        id: "Payment Log"
      }
    ]
  },
  {
    key: "MENU_BAR.ADMIN.OTHERS.ROOT",
    subItems: [
      {
        key: "MENU_BAR.ADMIN.OTHERS.RESOURCE_MANAGER",
        id: "Resource Manager"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.REFERENCES",
        id: "References"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.DOCUMENTS",
        id: "Documents"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.EMAIL_BLASTER",
        id: "Email Blaster"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.NOTIFICATION_CENTER",
        id: "Notification Center"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.SNAPSHOT",
        id: "Metrics & Analysis (Snapshot)"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.COMMUNITY",
        id: "Community"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.DAILY_RESOURCE_MANAGER",
        id: "Daily Resource Manager"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.GLOBAL_PREDEFINED_VALUES",
        id: "Global Predefined Values"
      },
      {
        key: "MENU_BAR.ADMIN.USERS.ADMINISTRATORS",
        id: "Administrators"
      },
      {
        key: "MENU_BAR.ADMIN.JOBS_EVENTS.PERSONAL_TO_DO",
        id: "Personal To Do"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.BENEFIT_MANAGER",
        id: "Benefit Manager"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.BENEFITS",
        id: "Benefits"
      },
      {
        key: "MENU_BAR.ADMIN.OTHERS.TRASH",
        id: "Trash"
      },
    ]
  }
];

export const TOP_MENU_ALL_ITEMS = [
  {
    key: "MENU_BAR.TOP.MARKETPLACE",
    id: "Marketplace"
  },
  {
    key: "MENU_BAR.TOP.CANDIDATE_COMMUNITY",
    id: "Enginehire Candidate Community"
  },
  {
    key: "MENU_BAR.TOP.COMMUNITY",
    id: "Enginehire Community"
  },
  {
    key: "MENU_BAR.TOP.MESSAGES",
    id: "Users Messages"
  },
  {
    key: "MENU_BAR.TOP.SMS",
    id: "SMS Communication"
  },
  // {
  //   key: "MENU_BAR.TOP.JOBS",
  //   id: "Agency Job Board"
  // },
  {
    key: "MENU_BAR.TOP.LOGOUT",
    id: "Logout"
  },
  {
    key: "MENU_BAR.TOP.DASHBOARD",
    id: "Dashboard"
  }
];

export const ENGINEHOW_MENU_ITEMS = ["Application & Profile Builder", "Evaluation Builder", "Clients", "Email Templates", "Document Templates", "Agency", "Email Blaster"]
export const CANDIDATE_MENU_ALL_ITEMS = [
  {
    key: "MENU_BAR.CANDIDATES.MY_PROFILE",
    id: "My Profile",
    icon: "contact_page"
  },
  {
    key: "MENU_BAR.CANDIDATES.AVAILABLE_JOBS",
    id: "Available Jobs",
    icon: "work_outline"
  },
  {
    key: "MENU_BAR.CANDIDATES.MY_SCHEDULE",
    id: "My Schedule",
    icon: "event_available"
  },
  {
    key: "MENU_BAR.CANDIDATES.MY_JOBS",
    id: "My Jobs",
    icon: "work"
  },
  {
    key: "MENU_BAR.CANDIDATES.MY_FAMILIES",
    id: "My Families",
    icon: "house"
  },
  {
    key: "MENU_BAR.CANDIDATES.BENEFITS",
    id: "Benefits",
    icon: "emoji_events"
  }
];

export const LIST_ALL_MENU_IDS = [
  "Clients",
  "Candidates",
  "Personal To Do",
  "Shift Job Calendar",
  "Jobs",
  "References",
  "Documents",
  "Email Blaster",
  "Admin Setting",
  "Email Templates",
  "SMS Templates",
  "Document Templates",
  "Note Templates",
  "Task Templates",
  "Profile Templates",
  "Push Notification Templates",
  "Resource Manager",
  "Evaluation Builder",
  "Communication Log",
  "User Messages Log",
  "Payment Log",
  "Administrators",
  "Agency",
  "Application & Profile Builder",
  "Notification Center",
  "Status Changes",
  "Activity Log",
  "Application Log",
  "Metrics & Analysis (Snapshot)",
  "Home",
  "Community",
  "Trash"
];

export const USER_PANEL_MENU_ITEMS = [
  {
    key: 'MENU_BAR.ADMIN_PANEL.LISTS',
    tab: 'lists',
    icon: 'checklist'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.NOTES',
    tab: 'notes',
    icon: 'note'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.EMAIL_SMS',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.EMAIL_SMS',
    tab: 'email_sms',
    icon: 'mail'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.EVENT',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.EVENT',
    tab: 'event',
    icon: 'event'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.PASSWORD',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.PASSWORD',
    tab: 'password',
    icon: 'password'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.PAYMENTS',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.PAYMENTS',
    tab: 'payments',
    icon: 'payment'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.PAYMENTS_CREDIT',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.PAYMENTS',
    tab: 'payments',
    hasCredit: true,
    icon: 'payment'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.DOCUMENTS',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.DOCUMENTS',
    tab: 'documents',
    icon: 'text_snippet'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.EVALUATIONS',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.EVALUATIONS',
    tab: 'evaluations',
    icon: 'quiz'
  },
  {
    key: 'MENU_BAR.ADMIN_PANEL.RELATIONSHIPS',
    keyMobile: 'MENU_BAR.ADMIN_PANEL_SHORT.RELATIONSHIPS',
    tab: 'relationships',
    icon: 'group_add'
  }
]


// WEBPACK FOOTER //
// ./src/constants/menu-items.js